import { Box } from "@outschool/backpack";
import React from "react";

import { useStickyHeader } from "../../hooks/useStickyHeader";

const StickyHeaderConatiner = React.forwardRef<
  HTMLDivElement,
  { children: React.ReactNode }
>(({ children }, ref) => {
  const { enabled } = useStickyHeader();
  const headerContainerStyle = enabled
    ? {
        position: "sticky",
        top: 0,
        zIndex: 201
      }
    : {};

  return (
    <Box ref={ref} sx={headerContainerStyle}>
      {children}
    </Box>
  );
});

export default StickyHeaderConatiner;
